import { 
    LOGIN_USER_START,
  FETCH_TOKEN,
  LOGIN_USER_FAIL,
    LOGIN_USER_SUCCESS,
    RESET_PASSWORD_FAIL,
    LOGOUT_USER
   } from "../Types";
   
   const INITIAL_STATE = {
    register_error: '',
    user: null,
    isLogin: null,
       login_error: '',
    reset_error:''
  }

  export default(state = INITIAL_STATE, action) => {
    switch(action.type) {    
      case LOGIN_USER_START:
       return { ...state, isLoading: true, login_error: ''};
       case  FETCH_TOKEN:     
              return { ...state,           
                isLogin: true,
                user: action.payload
               };
       case LOGIN_USER_SUCCESS:
              return { ...state, isLoading: false, isLogin:true, login_error: ''};
        case LOGIN_USER_FAIL:         
            return { ...state, login_error: action.payload, isLoading: false, isLogin: false, password: '' }
        case RESET_PASSWORD_FAIL:
            return { ...state, reset_error: action.payload }
        case LOGOUT_USER:
            return {...state, isLogin: false}
       default: return state;
     
    }
  }


// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.js